import { mediaQueries, typography, size, colors } from '@everlywell/leaves';
import styled from 'styled-components';

type PriceSectionProps = {
  showDiscount: boolean;
  isTextReduced?: boolean;
};

export const DiscountedPrice = styled.p`
  ${typography.displayText}
  text-transform: uppercase;
  font-weight: ${typography.weight.book};
  color: ${colors.red3};
  margin-left: ${size.xs2}px;
`;

export const SavingsText = styled.p`
  ${typography.captionText};
  margin-left: 6px;
  line-height: ${size.md}px;
  letter-spacing: 0.3px;
  color: ${colors.red3};
  font-weight: ${typography.weight.xbold};
  min-width: ${size.xl8}px;
  margin-top: ${size.xs2}px;
  ${mediaQueries.forTabletVerticalUp} {
    margin-top: 0;
  }
`;

export const PriceAmount = styled.div`
  display: flex;
  align-items: baseline;
`;

export const ProductPrice = styled.h3`
  font-weight: ${typography.weight.light};
  color: ${colors.gray4};

  ${mediaQueries.forTabletVerticalUp} {
    font-size: 22.8px;
  }
`;

export const PriceSection = styled.div<PriceSectionProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: ${({ isTextReduced }) => !isTextReduced && `${size.xl1}px`};
  justify-content: flex-start;

  ${mediaQueries.forTabletVerticalUp} {
    min-height: ${({ isTextReduced }) => !isTextReduced && `${size.xl4}px`};
    margin-top: 0;
  }

  ${mediaQueries.forDesktopUp} {
    min-height: ${({ isTextReduced }) => !isTextReduced && `${size.xl3}px`};
    margin-left: 0;
    margin-top: ${({ isTextReduced }) => !isTextReduced && `${size.lg}px`};
  }

  ${({ showDiscount }) =>
    showDiscount &&
    `
      ${ProductPrice} {
        padding-top: ${size.xs2};
        ${typography.bodyText};
        font-weight: ${typography.weight.book};
        line-height: 28px;
        text-decoration: line-through;
        text-decoration-thickness: ${size.xs3}px;

        ${mediaQueries.forTabletVerticalUp} {
          ${typography.displayText};
        }

        ${mediaQueries.forDesktopUp} {
          padding-top: 0;
        }
      }
    `}

  ${({ isTextReduced }) =>
    isTextReduced &&
    `
      ${ProductPrice} {
        ${typography.bodyTextSmall}
        font-weight: ${typography.weight.regular};
        ${mediaQueries.forTabletHorizontalUp} {
          ${typography.subtitle};
        }
      }

      ${DiscountedPrice} {
        ${typography.bodyText}

        ${mediaQueries.forTabletHorizontalUp} {
          ${typography.h5Text};
        }
      }
    `}
`;

export const PromoText = styled.p`
  width: 100%;
  color: ${colors.red3};
  font-weight: ${typography.weight.bold};
`;
